module.exports = __webpack_public_path__ + "static/media/eye-view.be8ac7ee.svg";